import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";

const COLS = [
  {
    title: "Shop",
    links: [
      { to: "/shop", label: "All Products" },
      { to: "/shop?category=study", label: "Study Planners" },
      { to: "/shop?category=budget", label: "Budget Planners" },
      { to: "/shop?category=habits", label: "Habit Trackers" },
      { to: "/shop?category=templates", label: "Editable Templates" },
    ],
  },
  {
    title: "Studio",
    links: [
      { to: "/order-lookup", label: "Find My Downloads" },
      { to: "/about", label: "About" },
      { to: "/contact", label: "Contact" },
      { to: "/faq", label: "FAQ" },
    ],
  },
  {
    title: "Fine Print",
    links: [
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/policies", label: "Shop Policies" },
      { to: "/domain-setup", label: "Custom Domain Setup" },
    ],
  },
];

export const Footer = () => (
  <footer className="border-t border-sage/10 bg-cream-dark/60" data-testid="footer">
    <div className="mx-auto grid max-w-7xl gap-10 px-6 py-16 md:grid-cols-12 md:px-8">
      <div className="md:col-span-5">
        <div className="flex items-center gap-3">
          <LogoMark size={34} />
          <span className="font-serif text-2xl text-ink">Bloom Paper Studio</span>
        </div>
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-ink/60">
          Tactile digital downloads for intentional living. Original planners, trackers and
          templates, delivered instantly after secure checkout.
        </p>
        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-sage">
          Secure checkout by Stripe
        </p>
      </div>
      {COLS.map((col) => (
        <div key={col.title} className="md:col-span-2">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-lavender-deep">{col.title}</p>
          <ul className="mt-4 space-y-2.5">
            {col.links.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-ink/65 transition-colors hover:text-sage">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="border-t border-sage/10 py-6 text-center">
      <p className="text-xs text-ink/45">
        © {new Date().getFullYear()} Bloom Paper Studio. All designs are original works.
      </p>
    </div>
  </footer>
);
